import { io } from "socket.io-client";

export const socket = io(window.socket_url);
